import React from 'react';
import { SearchRecord } from 'types/record';
import { Search } from 'types/search';
import {
  allSearchRecords,
  formatSearchTitle,
  getChargeTitle,
  getChargeDate,
} from '../../../../../../lib/screenings';
import CandidateStoriesMultiSelect from './CandidateStoriesMultiSelect';

type Props = {
  search: Search;
  toggleRecord: (value: SearchRecord) => void;
  selectedRecords: SearchRecord[];
};

const ChargesByRecordForm = ({
  search,
  toggleRecord,
  selectedRecords,
}: Props) => {
  const recordSelected = (recordId: string) => {
    return !!selectedRecords.find((item: SearchRecord) => item.id === recordId);
  };

  return (
    <div className='mb-4' data-testid='charges-by-record-form'>
      <div className='mb-2'>
        <b>{formatSearchTitle(search)}</b>
      </div>
      <div className='form-group'>
        {allSearchRecords(search).map((record: SearchRecord) => (
          <CandidateStoriesMultiSelect
            key={record.id}
            displayValue={getChargeTitle(record)}
            selectValue={record}
            toggleValue={toggleRecord}
            date={getChargeDate(record)}
            selected={recordSelected(record.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default ChargesByRecordForm;
